export const PHONE_RU = '+7 999 999-99-99';
export const PHONE_UA = '+38 099 999-99-99';

export const SMS_CODE = '9 9 9 9';